import { useContext } from "react";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { TApiButtonCommandFn } from "containers/DynamicForm/useButtonCommand";
import { retryNextForm } from "store/actions/flow";
import { useAppDispatch, useAppSelector } from "store/index";

import { find } from "lodash-es";

// executes 'nextForm' action in background (without loader)
export const useRetryNextForm = () => {
  const dispatch = useAppDispatch();
  const flowSessionId = useAppSelector(state => state.formFlow.flowSessionId);
  const { dynamicForm, inputs } = useContext(DynamicFormContext);

  const nextFormCommand: TApiButtonCommandFn = async (commandArgs, { formAction, formScope }) => {
    const actionArgumentSource = find(commandArgs, ["name", "action"])?.source;
    const actionArgumentSourceType = find(commandArgs, ["name", "action"])?.sourceType;
    const actionValue =
      actionArgumentSourceType === "static"
        ? actionArgumentSource
        : find(inputs, ["key", actionArgumentSource])?.value;
    const criteriaAction = actionValue || formAction;

    const criteriaAttributes = {
      ...(!!criteriaAction && { action: String(criteriaAction) }),
      ...(!!formScope && { formScope }),
    };

    const retryArguments = commandArgs?.filter(argument =>
      ["retryBackoffFactor", "retryDelay", "retryTimeout"].includes(argument.name)
    );

    return await dispatch(
      retryNextForm({
        criteria: criteriaAttributes,
        currentFormIdentifier: dynamicForm.id,
        direction: "next",
        flowSessionId,
        retryArguments,
      })
    ).unwrap();
  };

  return nextFormCommand;
};
